import React from 'react'
import './styles.scss'

const HeaderLogin: React.FC<any> = ({ children }) => {
  return <div className="header-login">{children}</div>
}
export default HeaderLogin
